var ProviderType;
(function (ProviderType) {
    ProviderType["Agency"] = "Agency";
    ProviderType["Freelance"] = "Freelance";
    ProviderType["Any"] = "Any";
})(ProviderType || (ProviderType = {}));
export default ProviderType;
